import { FC } from 'react';
import { useIntl } from 'react-intl';
import {
  StyledPrintCheckDialogContent,
  StyledPrintCheckLabel,
  StyledPrintCheckValue,
  StyledPrintFailedComment
} from 'pages/VendorsTablePage/components/dialogs/PrintChecksDialog/styled';

import { labels } from './messages';
import { PrintFailureTable } from './PrintFailureTable';
import { DialogContentType } from './types';

export const DialogContent: FC<DialogContentType> = ({
  paymentDate,
  reason
}) => {
  const intl = useIntl();
  const errorMessage =
    reason || intl.formatMessage(labels.printCheckFailedUnknown);

  return (
    <>
      <StyledPrintCheckDialogContent>
        <StyledPrintCheckLabel>
          {intl.formatMessage(labels.paymentDateLabel)}
        </StyledPrintCheckLabel>
        <StyledPrintCheckValue>{paymentDate}</StyledPrintCheckValue>
      </StyledPrintCheckDialogContent>
      <StyledPrintFailedComment>{errorMessage}</StyledPrintFailedComment>
      <PrintFailureTable />
    </>
  );
};
